import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai"; // ✅ Import icon
import ToggleSwitch from "./ToggleSwitch";
import { FaExternalLinkAlt } from "react-icons/fa";

const BusinessSettingsForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    receiptPrefix: "",
    taxSetting: "",
    discountSetting: "",
    roundOff: false,
    tableManagement: false,
    paymentMode: "YB - 1",
  });

  const IconButton = ({ to }) => (
    
    <FaExternalLinkAlt onClick={() => navigate(to)}
      className="text-primary cursor-pointer text-lg"/>
  );

  return (
    <div className="mx-auto bg-white rounded-xl shadow-md p-6 space-y-4">
      <h2 className="text-xl font-semibold text-gray-800">Business Settings</h2>

      <div>
        <div className="flex gap-4 mb-1">
          <label>Receipt ID Prefix</label>
          <IconButton  to="/reciptsPrefix" />
        </div>
        <input type="text" className="input" value={formData.receiptPrefix} />
      </div>

      <div>
        <div className="flex gap-4 mb-1">
          <label>Tax Settings</label>
          <IconButton to="/own-tax-values" />
        </div>
        <input type="text" className="input" value={formData.taxSetting} />
      </div>

      <div>
        <div className="flex gap-4 mb-1">
          <label>Discount Settings</label>
          <IconButton to="/discount-settings" />
        </div>
        <input type="text" className="input" value={formData.discountSetting} />
      </div>
      <div>
        <div className="flex gap-4 mb-1">
          <label>Delivery Settings</label>
          <IconButton to="/dilivery-settings" />
        </div>
        <input type="text" className="input" value={formData.discountSetting} />
      </div>
      <div>
        <div className="flex gap-4 mb-1">
          <label>Packings Fee</label>
          <IconButton to="/packing-fee" />
        </div>
        <input type="text" className="input" value={formData.discountSetting} />
      </div>
      <div>
        <div className="flex gap-4 mb-1">
          <label>Service Fee</label>
          <IconButton to="/service-fee" />
        </div>
        <input type="text" className="input" value={formData.discountSetting} />
      </div>
      <div>
        <div className="flex gap-4 mb-1">
          <label>Other Fee</label>
          <IconButton to="/other-fee" />
        </div>
        <input type="text" className="input" value={formData.discountSetting} />
      </div>

      <ToggleSwitch
        label="Round Off (Automatically round decimal)"
        checked={formData.roundOff}
        onChange={() => setFormData({ ...formData, roundOff: !formData.roundOff })}
      />

      <ToggleSwitch
        label="Table Management (Replace Park with Table)"
        checked={formData.tableManagement}
        onChange={() =>
          setFormData({ ...formData, tableManagement: !formData.tableManagement })
        }
      />

      <div>
        <div className="flex gap-4 mb-1">
          <label>Payment Mode Settings</label>
          <IconButton to="/payment-settings" />
        </div>
        <input type="text" className="input" value={formData.paymentMode} />
      </div>

      <button className="w-full py-2 bg-primary text-white rounded-md">
        Delete Business or Reset
      </button>
    </div>
  );
};

export default BusinessSettingsForm;
